import axios from 'axios';

import { AdminSettings } from 'components/types';

import { ADMIN_SETTINGS_GROUP } from '../endpoints';

export const getAIMatchNotificationSettings = () =>
  axios.get<AdminSettings[]>(ADMIN_SETTINGS_GROUP, {
    params: {
      groupName: 'notification-settings'
    }
  });

export const updateAIMatchNotificationSettings = (payload: AdminSettings) =>
  axios.put<AdminSettings[]>(
    `${ADMIN_SETTINGS_GROUP}/${payload.groupId}`,
    payload
  );
